const clinicianWizard = (() => {
    const initBlock = el => {
        handleStep1Data(el);
    };

    const attachPressEnterListener = (textField, button) => {
        if (textField && button) {
            textField.addEventListener("keyup", e => {
                if (textField.value && e.keyCode === 13) {
                    button.dispatchEvent(new Event("click"));
                }
            });
        }
    }

    const showStep = (stepNum) => {
        window.location.href = `#${stepNum}`;

        document.querySelector(".wizard").scrollTo(0,0);
    }

    const handleStep1Data = (el) => {
        const lastPage = document.referrer || "/";
        const step1 = el.querySelector('[data-step-1]');

        if (step1.isBound) {
            return;
        }
        
        const searchTypeWrap = step1.querySelector('[data-step-1-search-type]');
        const continueButton = step1.querySelector('[data-next-step]');
        const backButton = step1.querySelector('[data-prev]');

        setTimeout(() => {
            showStep(1);
        }, 150);
        
        continueButton.addEventListener('click', () => {
            const selectedCategory = searchTypeWrap.querySelector('input[name="searchType"]:checked');
            if (selectedCategory) {
                step1.classList.remove('wizard--error');
                if (selectedCategory.value === 'name') {
                    handleStep2Data(el);
                    showStep(2);
                } else if (selectedCategory.value === 'condition') {
                    handleStep3Data(el);
                    showStep(3);
                }
            } else {
                step1.classList.add('wizard--error');
            }
        });
        backButton.addEventListener('click', () => window.location.href = lastPage);
        
        step1.isBound = true;
    }

    const handleStep2Data = (el) => {
        const step2 = el.querySelector('[data-step-2]');
        
        if (step2.isBound) {
            return;
        }
        
        const clinicianNameWrap = step2.querySelector('[data-step-2-clinician-name]');
        const continueButton = step2.querySelector('[data-next-step]');
        const backButton = step2.querySelector('[data-prev]');
        continueButton.addEventListener('click', () => {
            const clinicianName = clinicianNameWrap.querySelector('input[name="clinicianName"]');
            if (clinicianName && clinicianName.value !== '') {
                step2.classList.remove('wizard--error');
                const loading = el.querySelector('[data-loading]');
                loading.classList.remove('hidden');
                const form = el.querySelector('form[data-clinician-wizard-form]');
                const clinicianNameField = form.querySelector('input[name="name"]');
                clinicianNameField.value = clinicianName.value;
                form.querySelector('input[name="category"]').value = "all";
                form.submit();
                showStep("loading");
                window.addEventListener('unload', function(event) {
                    // Cleanup or telemetry actions
                    showStep("4");
                });
            } else {
                step2.classList.add('wizard--error');
            }
        });
        backButton.addEventListener('click', () => {
            history.back();
        });

        attachPressEnterListener(clinicianNameWrap.querySelector('input[name="clinicianName"]'), continueButton);
        
        step2.isBound = true;
    }

    const handleStep3Data = (el) => {
        const step3 = el.querySelector('[data-step-3]');
        
        if (step3.isBound) {
            return;            
        }

        const all = step3.querySelector('[data-checkbox-all]');
        const checkboxes = Array.from(step3.querySelectorAll('[data-checkbox]'));
        const conditionSearchInput = el.querySelector('input[name="conditionsSearchInput"]');
        const continueButton = step3.querySelector('[data-next-step]');
        const backButton = step3.querySelector('[data-prev]');
        conditionSearchInput.addEventListener('input', () => {
            const value = conditionSearchInput.value;
            checkboxes.forEach(checkbox => {
                checkbox.classList.remove('flag-wrap__flag--hidden');
                if (value.length > 2) {
                    if (checkbox.dataset.checkbox.toLowerCase().includes(value.toLowerCase())) {
                        checkbox.classList.remove('flag-wrap__flag--hidden');
                    } else {
                        checkbox.classList.add('flag-wrap__flag--hidden');
                    }
                }
            });
        });
        
        checkboxes.forEach(checkBox => {
            const input = checkBox.querySelector("input");
            
            input.addEventListener("input", () => {
                if (all) {
                    all.querySelector("input").checked = checkboxes.filter(x => x.querySelector("input").checked).length === checkboxes.length;
                }
            });
        });
        
        if (all){
            all.addEventListener('input', () => {
                checkboxes.forEach(checkbox => checkbox.querySelector('input').checked = all.querySelector("input").checked);
            });
        }
        continueButton.addEventListener('click', () => {
            let conditions = [];            
            step3.querySelectorAll('input[name="condition"]:checked').forEach(condition => {
                conditions.push(condition.value);
            });
            const form = el.querySelector('form[data-clinician-wizard-form]');
            const clinicianConditionsField = form.querySelector('input[name="category"]');            
            if (conditions.includes('all')){
                clinicianConditionsField.value = 'all';
            } else {
                clinicianConditionsField.value = conditions.join(',');
            }
            if (clinicianConditionsField.value === ''){
                step3.classList.add('wizard--error');                
            } else {
                step3.classList.remove('wizard--error');
                handleStep4Data(el);
                showStep(4);
            }
        });
        backButton.addEventListener('click', () => {
            history.back();            
        });
        
        step3.isBound = true;
    }
    
    const handleStep4Data = (el) => {
        const step4 = el.querySelector('[data-step-4]');
        
        if (step4.isBound) {
            return;
        }
        
        const ageGroupWrap = step4.querySelector('[data-step-4-age-group]');
        const jobTypeWrap = step4.querySelector('[data-step-4-job-type]');
        const continueButton = step4.querySelector('[data-next-step]');
        const backButton = step4.querySelector('[data-prev]');
        continueButton.addEventListener('click', () => {
            const ageGroup = ageGroupWrap.querySelector('input[name="ageGroup"]:checked');
            const jobType = jobTypeWrap.querySelector('input[name="jobType"]:checked');
            if (ageGroup && jobType){
                step4.classList.remove('wizard--error');
                const loading = el.querySelector('[data-loading]');
                loading.classList.remove('hidden');
                const form = el.querySelector('form[data-clinician-wizard-form]');
                const ageGroupField = form.querySelector('input[name="ageGroup"]');
                const jobTypeField = form.querySelector('input[name="jobType"]');
                ageGroupField.value = ageGroup.value;
                jobTypeField.value = jobType.value;
                form.submit();
                showStep("loading");
                window.addEventListener('unload', function(event) {
                    // Cleanup or telemetry actions
                    showStep("4");
                });
            } else {
                step4.classList.add('wizard--error');
            }
        });
        backButton.addEventListener('click', () => {
            history.back();
        });
        
        step4.isBound = true;
    };

    window.onpageshow = (e) => {
        if (e.persisted) {
            showStep(1);
        }
    }

    return {initBlock};
})();

ControlBinders.register(`[data-clinician-wizard]`, el => clinicianWizard.initBlock(el));